<template>
  <BaseModal overlay-class="zb_modal">
    <div class="content">
      <BaseImage src="/static/images/other/games_left_no.svg" alt="Zero Balance" />

      <h3 class="top_title">
        {{ $_translations.value.modal_zero_balance_game_title_pt1 }}
        <span class="yellow_bold">
          {{ $_translations.value.modal_zero_balance_game_title_pt2 }}
        </span>
        {{ $_translations.value.modal_zero_balance_game_title_pt3 }}
      </h3>

      <template v-if="!appSettings.isStoreDisabled">
        <p>{{ $_translations.value.modal_zero_balance_game_description }}</p>

        <BaseButton @click:button="$emit('redirect:storePage')">
          {{ $_translations.value.modal_zero_balance_game_button_proceed }}
        </BaseButton>
      </template>
    </div>
  </BaseModal>
</template>

<script setup>
import BaseModal from '@/components/modal/BaseModal.vue';
import BaseImage from '@/components/image/BaseImage.vue';
import BaseButton from '@/components/button/BaseButton.vue';
import useAppSettingsStore from '@/store/modules/appSettings.js';

defineEmits(['redirect:storePage']);

const appSettings = useAppSettingsStore();
</script>
